import React, { Fragment } from "react";
import { Card, Row, Col, Button } from 'react-bootstrap';
import '../../../../../../styles/balanco.scss'
import moment from "moment";

const Inscricao = (props) => {

    moment.locale('pt');
    moment.updateLocale('pt', {
        months: [
            "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho",
            "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
        ]
    });
    const dataNasc = moment(props.inscricao.dataNasc).utc(false).format("DD/MM/YYYY");

    const deletar = async (id) => {
        props.deletar(id)
        await props.fetchInscricoesIn()
    }

    const editar = async (id) => {
        props.editar(id)
    }

    var msg = 'Olá, ' + props.inscricao.nomeCompleto + ' vim comunicar a respeito da sua inscrição na Conferência Municipal de Saúde do Município de Macuco';
    var classes = 0
    var inscrito = false

    switch (props.inscricao.situacao) {
        case "Pendente":
            classes = "card-list redd";
            break;
        case "Inscrito":
            inscrito = true
            classes = "card-list grre";
            break;
    }

    return (
        <Fragment>
            <Col>
                <Card className={classes}>
                    <Card.Body>
                        <Card.Title className="cabeca-card" key={props.key}>{props.inscricao.nomeCompleto}</Card.Title>
                        <p>Endereço: <strong>{props.inscricao.endereco}</strong></p>
                        <p>Município: <strong>{props.inscricao.municipio}</strong></p>
                        <p>Bairro: <strong>{props.inscricao.bairro}</strong></p>
                        <p>Data de Nascimento: <strong>{dataNasc}</strong></p>
                        <p>Telefone: <strong>{props.inscricao.telefone}</strong></p>
                        <p>Email: <strong>{props.inscricao.email}</strong></p>
                        <p>Segmento: <strong>{props.inscricao.seguimentoSaude}</strong></p>
                        <p>Eixo: <strong>{props.inscricao.eixoDebate}</strong></p>
                        <p><strong>{props.inscricao.inscritoComo}</strong></p>
                        <p>Faz parte do conselho de Macuco? <strong>{props.inscricao.conselhoMacuco}</strong></p>
                        <p>Status da inscrição: <strong>{props.inscricao.situacao}</strong></p>
                    </Card.Body>
                    <hr />
                    {inscrito ?
                        <Button type="button" className="botao-leis" onClick={() => editar(props.inscricao._id)} variant='warning'>Cancelar inscrição</Button>
: <Button type="button" className="botao-leis" onClick={() => editar(props.inscricao._id)} variant='primary'>Validar inscrição</Button>}
                    {props.inscricao.telefone ?
                        <a target="_blank" rel="noreferrer" href={`https://api.whatsapp.com/send/?phone=55${props.inscricao.telefone}&text=${encodeURIComponent(msg)}`}>
                            <Button type='button' className="botao-leis" variant='success'>
                                Chamar no WhatsApp</Button>
                        </a> : ''}
                    <Button type='button' className="botao-leis" onClick={() => deletar(props.inscricao._id)} variant='danger'>Excluir</Button>
                </Card>
            </Col>
        </Fragment >)
}

export default Inscricao;